import { FEATURE_INBOX_CANNED_REPLIES_TIER_1 } from 'ducks/billing/featureTypes'
import { selectFeatureUsage } from 'ducks/billing/selectors/features'

export const selectIsCustomFieldsEnabled = state =>
  selectFeatureUsage(state, FEATURE_INBOX_CANNED_REPLIES_TIER_1)?.canUseFeature
